module.exports = __webpack_public_path__ + "img/barcode-read.15913eb7.svg";